'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('./module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../webComponents/utils');

var _utils2 = require('../core/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WinresReservationContext]');

// Reservation context directive, i.e. element which wraps all reservation
// components on the page (at least those which are connected to the same
// reservation process / destination / something)

var WinresReservationContextController = function () {
    function WinresReservationContextController($q, $scope, $rootScope, $timeout, $document, $location, winresReservationContextService, destinationService, localizationService, reservationService, departureService, loadingOverlayService, productService, winresCloudService, customerService, ownerService, cancelService, analyticsService, urlService) {
        _classCallCheck(this, WinresReservationContextController);

        if ($scope.isDestination === 'true') {
            urlService.isFixedKohdeSivu = true;
        }
        if ($scope.language) {
            var lang = $scope.language;
            var dash = lang.indexOf('-');
            if (dash !== -1) {
                var fullCode = lang;
                lang = lang.substr(0, dash);
                log.warn('Language code should not have a dash. Interpreting:', fullCode, '=>', lang);
            }
            localizationService.setLanguage(lang);
        } else if ($scope.useHtmlLang === 'true') {
            var htmlE = window && window.document && window.document.documentElement;
            var _lang = htmlE && htmlE.lang;
            if (_lang && _lang.length >= 2) {
                _lang = _lang.substring(0, 2);
                log('Using the html element\'s lang attribute ("' + _lang + '").');
                localizationService.setLanguage(_lang);
            } else {
                log.warn('The context has use-html-lang="true", but the html element\'s lang attribute has an invalid value ("' + _lang + '").');
            }
        }
        this.winresCloudService = winresCloudService;
        this.customerService = customerService;
        this.customFieldsPrepend = [];
        this.customFieldsAppend = [];
        this.$q = $q;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$document = $document;
        this.$location = $location;
        this.localizationService = localizationService;
        this.reservationService = reservationService;
        this.departureService = departureService;
        this.loadingOverlayService = loadingOverlayService;
        this.winresReservationContextService = winresReservationContextService;
        this.productService = productService;
        this.loadingDestination = null;
        this.loadingDeparture = {
            "DestinationCode": null,
            "StartDate": null,
            "EndDate": null
        };
        this.ownerService = ownerService;
        this.cancelService = cancelService;
        this.analyticsService = analyticsService;
        this.urlService = urlService;
        window.definiteWinresReservationContext = this;
    }

    _createClass(WinresReservationContextController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Apply web component styles to loading overlay
            this.loadingOverlayService.webComponent = true;

            this.initUrlData();

            this.contextId = this.$scope.contextId;
            if (!this.contextId) {
                this.contextId = 'automatic-context-' + this.Params.destinationCode;
            }

            this.initContext();

            if (this.contextNonPersistent.InitializedInDirective) {
                log.warn("Context already initialized!", this.contextId);
                return;
            }
            this.contextNonPersistent.InitializedInDirective = true;

            this.initPassengerFieldsBase();
            this.initWatches();
            this.initPassengers();
            // this.initBus(this.$scope.busDeparture);
            this.loadDestination();
            this.loadDeparture();

            this.winresReservationContextService.handleReturnFromBank().then(function (result) {
                log("handleReturnFromBank(): Returned from bank: ", result);
                if (result === "cancel") {
                    _this.handleBankCancel();
                    log("handleReturnFromBank(): Bank canceled");
                } else if (result.Booking.Productlines.products) {
                    _this.analyticsEvent("returnFromBank", result.Booking);
                    _this.dataLayerEvent('onReturnFromBank', result.Booking);
                } else {
                    log.warn("handleReturnFromBank() but the result was not as expected: ", result);
                }
            }).catch(function (error) {
                // When not returning from bank the function in ContextSercive returns a rejected promise intentionally
                if (error === "Did not return from bank") {
                    //Normally should be undefined
                    // log("handleReturnFromBank(): Not returning from bank");
                } else {
                    // This should probably not happen
                    log.error("handleReturnFromBank() (This might happen if a page that has ?cancel after the URL) error: ", error);
                }
            });

            this.setCurrentPhase(this.$scope.startphase);
            this.$scope.$on('$locationChangeSuccess', function () {
                _this.initUrlData();
                _this.loadDestination();
                _this.loadDeparture();
            });

            // This code checks for element in the page that has id="white-loading-screen"
            // and some other code hides the cover when webcomponents loaded
            // the <div id="white-loading-screen" > is not a webcomponent but just a element
            // that has to be added to the page where webcomponents are placed
            // Apparently this is currently forced always to be on
            // if(this.$scope.initialLoadingScreen === 'true'){
            if (true) {
                if (document.getElementById("white-loading-screen")) {
                    var whiteScreenA = setTimeout(function () {
                        return document.getElementById("white-loading-screen").style.display = "none";
                    }, 6000); // Infinite white loading screen fix.

                    this.$scope.$on('i18nextLanguageChange', function () {
                        try {
                            var whiteScreenB = setTimeout(function () {
                                return document.getElementById("white-loading-screen").style.display = "none";
                            }, 1000); // To fix possible error with angular.element
                            angular.element(document.querySelector('#white-loading-screen').style.display = "none");
                            //clearTimeout(whiteScreenA);
                            clearTimeout(whiteScreenB);
                        } catch (e) {
                            log.warn("Loading cover not found. If you want the white loading screen, you must  you must add the < div id=\"white-loading-screen\" >< / div > element to the page just after body. ", e);
                        }
                    });
                } else if (!document.getElementById("white-loading-screen")) {
                    log.warn("Loading cover not found. If you want the white loading screen, you must  you must add the < div id=\"white-loading-screen\" >< / div > element to the page just after body. ");
                } else {
                    log.error("white-loading-screen error");
                }
            }

            // If the user selects a departure, the frontend checks whether
            // the departure is unavailable. This is set to a promise resolving
            // to a list of blockers (reasons why the departure is unavailable).
            // Otherwise, this is set to a promise that resolves to an empty list (no blockers) immediately.
            // This is done to keep compatibility with old stuff and non-departures.
            this.blockerCheck = this.$q.resolve([]);

            // Try open shopping cart.
            setTimeout(function () {
                return _this.tryAutoOpenCart();
            });
        }

        // This returns the total price of the current cart,
        // taking absolutely everything into account.

    }, {
        key: 'getTotalPrice',
        value: function getTotalPrice() {
            if (!this.context) return 0;

            var lines = _.concat(this.context.Products || [], this.context.DiscountProducts || []);

            var linesTotal = _.sumBy(lines, function (line) {
                return line.TotalPrice || 0;
            });
            var hiddenPrice = this.context.HiddenPrice || 0;
            var reservationFee = this.$rootScope.reservationFee || 0;

            var total = linesTotal + hiddenPrice + reservationFee;

            return total;
        }
    }, {
        key: 'tryAutoOpenCart',
        value: function tryAutoOpenCart() {
            // Open shopping cart if addToCart=1 is set in url.
            if (!(0, _utils2.getParameter)('addToCart') || (0, _utils2.getParameter)('addToCart') && (0, _utils2.getParameter)('addToCart') !== '1') {
                return;
            }

            // Open shopping cart.        
            window.showShoppingBasket();
        }
    }, {
        key: 'checkBlockers',
        value: function checkBlockers() {
            var dep = this.context && this.context.SelectedDeparture;
            if (dep) {
                if (this.blockerCheck) {
                    // Cancel previous check
                    this.cancelService.cancel(this.blockerCheck);
                }

                log('A departure was selected. Checking availability...');
                var check = this.departureService.checkDeparture(dep.DestinationCode, dep.DepartureDate, dep.ArrivalDate2);
                this.blockerCheck = check;
            } else {
                // Not a departure - resolve to empty blocker list (no blockers = available).
                this.blockerCheck = this.$q.resolve([]);
            }
        }
    }, {
        key: 'passesAvailabilityCheck',
        value: function passesAvailabilityCheck() {
            var promise = this.blockerCheck;
            if (promise && promise.$$state) {
                // If the check was performed, it must have finished
                // and it must have resulted in an empty list.
                return promise.$$state.status === 1 && _.isEmpty(promise.$$state.value);
            } else {
                // If the check was not performed, pretend it passed.
                return true;
            }
        }
    }, {
        key: 'handleBankCancel',
        value: function handleBankCancel() {
            // Remove cancel and reject from url.
            this.$location.search('cancel', null);
            this.$location.search('reject', null);

            this.bankCanceled = true;
            //document.cookie = "tab=1";
        }
    }, {
        key: 'isLoggedIn',
        value: function isLoggedIn() {
            return this.winresCloudService.isLoggedIn();
        }
    }, {
        key: 'getUrlParams',
        value: function getUrlParams() {
            var params = this.urlService.readUrlParams(this.$scope.useSeo === 'true');

            // log('The URL parameters are:', params);

            if (params.na !== undefined && params.na !== null) {
                if (isNaN(params.na)) {
                    log.error("NumAdult parsed from URL is not a number! ", params.na);
                }
                params.na = parseInt(params.na, 10);
            }

            if (params.nc !== undefined && params.nc !== null) {
                if (isNaN(params.nc)) {
                    log.error("NumChildren parsed from URL is not a number! ", params.nc);
                }
                params.nc = parseInt(params.nc, 10);
            }

            if (params.ni !== undefined && params.ni !== null) {
                if (isNaN(params.ni)) {
                    log.error("NumInfants parsed from URL is not a number! ", params.ni);
                }
                params.ni = parseInt(params.ni, 10);
            }

            return {
                IsDeparture: this.$scope.isDeparture === 'true' || this.context && this.context.isDefinitelyDeparture || params.d,
                DestinationName: params.dn,
                DestinationCode: this.$scope.destinationCode || params.dc,
                ProductCode: this.$scope.productCode || params.pc,
                StartDate: this.$scope.startDate || params.bd,
                EndDate: this.$scope.endDate || params.ed,
                NumAdult: this.$scope.numAdults != null ? this.$scope.numAdults : params.na,
                NumChildren: this.$scope.numInfants != null ? this.$scope.numInfants : params.nc,
                NumInfants: this.$scope.numChildren != null ? this.$scope.numChildren : params.ni,
                StopID: params.si
            };
        }
    }, {
        key: 'initUrlData',
        value: function initUrlData() {
            // Url params split by /
            // useSeo = First param is destination name

            this.Params = this.getUrlParams();

            // if (this.Params.NumAdult !== undefined && this.Params.NumAdult !== null) {
            //     // log("NumAdult: ", this.Params.NumAdult);
            //     if(isNaN(this.Params.NumAdult)) {
            //         log.error("NumAdult parsed from URL is not a number! ", this.Params.NumAdult);
            //     }
            //   this.Params.NumAdult = parseInt(this.Params.NumAdult, 10);
            // }

            // if (this.Params.NumChildren !== undefined && this.Params.NumChildren !== null) {
            //   // log("NumChildren: ", this.Params.NumChildren);
            //   if(isNaN(this.Params.NumChildren)) {
            //     log.error("NumChildren parsed from URL is not a number! ", this.Params.NumChildren);
            //   }
            //   this.Params.NumChildren = parseInt(this.Params.NumChildren, 10);
            // }

            // if (this.Params.NumInfants !== undefined && this.Params.NumInfants !== null ) {
            //   // log("NumInfants: ", this.Params.NumInfants);
            //   if(isNaN(this.Params.NumInfants)) {
            //     log.error("NumInfants parsed from URL is not a number! ", this.Params.NumInfants);
            //   }
            //   this.Params.NumInfants = parseInt(this.Params.NumInfants, 10);
            // }
        }
    }, {
        key: 'isDepartureUrl',
        value: function isDepartureUrl() {
            if (this.$scope.isDeparture === 'true' || this.context && this.context.isDefinitelyDeparture) {
                return true;
            }

            switch ((0, _utils.readUrlPart)(this.$location, 0 + (this.$scope.useSeo ? 1 : 0))) {
                case 'departure':
                case 'lahto':
                    return true;
            }
            // Sanity check that URL is okay may not be quite waterproof
            // Checking if URL contains 'departure' or 'lahto'
            if (this.ifUrlContains("departure") || this.ifUrlContains("lahto")) {
                log.error("isDepartureUrl() is returning FALSE even though URL seems to contain 'departure' or 'lahto'. Make sure URL is okay. Check that departuresList outputs correct links containing SEO title etc..");
                log.error("isDepartureUrl() this.$scope.useSeo is:", this.$scope.useSeo);
                log("isDepartureUrl() readUrlPart(this.$location, 0 + (this.$scope.useSeo ? 1 : 0)):", (0, _utils.readUrlPart)(this.$location, 0 + (this.$scope.useSeo ? 1 : 0)));
            }
            return false;
        }
    }, {
        key: 'ifUrlContains',
        value: function ifUrlContains(string) {
            if (this.$location.path().indexOf(string) > -1) {
                return true;
            } else {
                return false;
            }
        }

        // _readUrlPartSkipStart(0) returns 'OETEST' for
        // /departure/OETEST and for /OETEST, i.e. this skips the optional mode
        // argument.

    }, {
        key: '_readUrlPartSkipPrefix',
        value: function _readUrlPartSkipPrefix(index) {
            var part = (0, _utils.readUrlPart)(this.$location, 0 + (this.$scope.useSeo ? 1 : 0));
            var hasPrefix = part == 'departure' || part == 'lahto' || part == 'day' || part == 'paiva';
            return (0, _utils.readUrlPart)(this.$location, index + (hasPrefix ? 1 : 0) + (this.$scope.useSeo ? 1 : 0));
        }

        // initBus(bus){
        //     if(bus && this.Params.BusRoute != null && this.Params.BusStopId != null){
        //         this.BusRoute = this.Params.BusRoute;
        //         this.BusStopId = this.Params.BusStopId;
        //         this.getBus(true, this.Params.StartDate);
        //         this.getBus(false, this.Params.EndDate);
        //     }
        // }

        // direction: true = go, false = return. SDED is the date the bus should be run.
        // getBus(direction, SDED){
        //     this.productService.getReservableProducts({
        //             DestinationCode: this.context.DestinationCode,
        //             StartDate: SDED,
        //             EndDate: SDED,
        //             MinCapacity: 0,
        //             GroupIDs: null,
        //             ProductType: 'bus'
        //         },
        //         this.localizationService.getLanguage()
        //     ).then(busProducts => {
        //         _.each(busProducts, i => {
        //                 if(i.LinkingInfo.Type == direction ? 'Go' : 'Return'){
        //                     var stops = i.BusStops;
        //                     _.each(stops, j => {
        //                         if(j.Id == this.BusStopId && j.Route == this.BusRoute){
        //                             j.BeginDate = i.BeginDate;
        //                             j.EndDate = i.EndDate;
        //                             direction ? this.context.GoBus = j : this.context.ReturnBus = j;
        //                         }
        //                     });
        //                 }
        //         });
        //     });
        // }

    }, {
        key: 'initContext',
        value: function initContext() {
            this.context = this.winresReservationContextService.getContext(this.contextId);

            this.contextNonPersistent = this.winresReservationContextService.getContextNonPersistent(this.contextId);

            this.createContextIfNoExisting();
        }
    }, {
        key: 'createContextIfNoExisting',
        value: function createContextIfNoExisting() {
            if (!this.context || typeof this.context.NumAdults === 'undefined') {
                this.context = {
                    NumAdults: 0,
                    NumChildren: 0,
                    NumInfants: 0,
                    DestinationCode: this.Params.destinationCode,
                    Destination: null,
                    Products: [],
                    ClerkID: this.$scope.clerkId,
                    OfficeID: this.$scope.officeId,
                    HiddenPrice: null,
                    MessageToBooking: null
                };
                this.winresReservationContextService.createContext(this.contextId, this.context);
            }
        }
    }, {
        key: 'updateReady',
        value: function updateReady() {
            if (this.Params.DestinationCode && !this.context.Destination || this.Params.IsDeparture && !this.context.SelectedDeparture) {
                $('body').removeClass('winres-webcomponents-ready');
            } else {
                // the trigger is there to trigger js inside (wordpress) theme
                $('body').addClass('winres-webcomponents-ready').trigger('components-ready');
            }
        }

        // Loads destination into context (session) from either the server or the
        // cache assuming that a destination is provided.

    }, {
        key: 'loadDestination',
        value: function loadDestination() {
            var _this2 = this;

            this.localSave3 = [];
            if (this.localSave3.length == 0) {
                this.localSave3 = this.context.Destination;
            }

            if (this.loadingDestination != this.Params.DestinationCode) this.context.Destination = null;

            if (this.Params.DestinationCode) {
                if (this.loadingDestination == this.Params.DestinationCode) {
                    log('Destination', this.Params.DestinationCode, 'is already loading.');
                    return;
                } else {
                    this.loadingDestination = this.Params.DestinationCode;
                }
                log('Loading destination:', this.Params.DestinationCode);
                this.context.DestinationCode = this.Params.DestinationCode;
                this.winresReservationContextService.loadDestinationIntoContext(this.context, this.Params.DestinationCode, this.$scope).then(function () {
                    log('Loaded destination.');
                    _this2.rebuildPassengerFields();
                    _this2.updateReady();
                    if (_this2.bankCanceled) {
                        _this2.$timeout(function () {
                            // Check if shopping cart is already opened by addToCart -param.
                            if (!(0, _utils2.getParameter)('addToCart') || (0, _utils2.getParameter)('addToCart') === 0) {
                                // Open shopping cart.
                                window.showShoppingBasket();
                            }
                        });
                    }
                }).catch(function (error) {
                    log.error("Failed loading destination:", error);
                });
            } else if (this.$scope.resetDefaultDatesOnDestinationChange === 'true') {
                log("Resetting default dates.");
                this.context.DefaultStartDate = null;
                this.context.DefaultEndDate = null;
            }

            //this makes sure that info does not disappear when coming back from payment. I m pretty sure this could be made some other way...
            this.$scope.$watchCollection(function () {
                return _this2.winresReservationContextService.getCurrentPhase();
            }, function () {
                if (_this2.localSave3Status() && _this2.winresReservationContextService.getCurrentPhase() == 'thankyou') {
                    _this2.context.Destination = _this2.localSave3;
                }
            });

            this.updateReady();
        }
    }, {
        key: 'localSave3Status',
        value: function localSave3Status() {
            if (this.localSave3 == null) {
                return false;
            } else if (this.localSave3.length != 0) {
                return true;
            }
            return false;
        }

        // Loads departure into context (session) from either the server or the
        // cache assuming that a departure is provided.

    }, {
        key: 'loadDeparture',
        value: function loadDeparture() {
            var _this3 = this;

            if (!this.Params.IsDeparture && this.context.SelectedDeparture && this.winresReservationContextService.getCurrentPhase() != 'thankyou') {
                // When moving away from a page containing departure, remove the
                // departure from the session.
                this.context.SelectedDeparture = null;
                if (this.$scope.multiDeparture !== 'true') {
                    this.context.Departures = [];
                }
                if (this.$scope.resetProductsOnDepartureChange == 'true') {
                    log('Departure has changed to NULL - resetting products.');
                    this.context.Products = [];
                    this.context.DiscountProducts = [];
                }
            }

            // The begin and end dates from the context are in
            // full ISO format (including the time and time zone).
            // The ones from the parameters are generally either
            // "2020-01-10" or "2020-1-10".
            // Thus, direct string comparisons, which this code
            // used to make, will fail.
            // Instead, convert everything to moments and compare
            // those.

            var fmt = function fmt(date) {
                return moment(date, [moment.ISO_8601, 'YYYY-M-D']).format('YYYY-MM-DD');
            };

            var sel = this.context.SelectedDeparture;
            var selBegin = sel ? fmt(sel.DepartureDate) : null;
            var selEnd = sel ? fmt(sel.ArrivalDate2) : null;

            var parBegin = fmt(this.Params.StartDate);
            var parEnd = fmt(this.Params.EndDate);

            // log('Selected departure from session:', sel && sel.DestinationCode, selBegin, selEnd);
            // log('Departure parameters:', this.Params.DestinationCode, parBegin, parEnd);

            if (this.Params.IsDeparture //Only load departures for departure URLs
            // I.e. it should not be loaded for day
            // capacity reservations.

            && this.Params.DestinationCode && this.Params.StartDate && this.Params.EndDate && !(sel && sel.DestinationCode == this.Params.DestinationCode && selBegin == parBegin && selEnd == parEnd)) {
                if (this.loadingDeparture.DestinationCode == this.Params.DestinationCode && this.loadingDeparture.StartDate == this.Params.StartDate && this.loadingDeparture.EndDate == this.Params.EndDate) {
                    return;
                } else {
                    log('Session departure', sel && sel.DestinationCode, selBegin, selEnd, 'does not match parameter departure', this.Params.DestinationCode, parBegin, parEnd);
                    this.loadingDeparture = {
                        "DestinationCode": this.Params.DestinationCode,
                        "StartDate": this.Params.StartDate,
                        "EndDate": this.Params.EndDate
                    };
                }

                // log("loadingDeparture", this.loadingDeparture);
                // log("loadingContext", this.context);
                this.localSave = [];
                this.localSave2 = [];

                if (this.$scope.resetProductsOnDepartureChange == 'true' && this.winresReservationContextService.bookingSessionId == null) {
                    if (this.localSave.length == 0) {
                        this.localSave = this.context.Products;
                    }
                    this.context.Products = [];
                    this.context.DiscountProducts = [];
                }

                if (this.localSave2.length == 0) {
                    this.localSave2 = this.context.SelectedDeparture;
                }

                this.context.SelectedDeparture = null;

                //this makes sure that info does not disappear when coming back from payment. I m pretty sure this could be made some other way...
                this.$scope.$watchCollection(function () {
                    return _this3.winresReservationContextService.getCurrentPhase();
                }, function () {
                    if (_this3.localSave.length != 0 && _this3.winresReservationContextService.getCurrentPhase() == 'thankyou') {
                        _this3.context.Products = _this3.localSave;
                    }
                    if (_this3.localSave2 != null && _this3.localSave2.length != 0 && _this3.winresReservationContextService.getCurrentPhase() == 'thankyou') {
                        _this3.context.SelectedDeparture = _this3.localSave2;
                    }
                    if (_this3.localSave3 != null && _this3.localSave3.length != 0 && _this3.winresReservationContextService.getCurrentPhase() == 'thankyou') {
                        _this3.context.Destination = _this3.localSave3;
                    }
                });

                if (this.$scope.multiDeparture !== 'true') {
                    this.context.Departures = [];
                }

                if (this.$scope.getCapacity == 'true') {
                    this.getDepartureCapacity = true;
                } else {
                    this.getDepartureCapacity = false;
                }

                this.winresReservationContextService.loadDepartureIntoContext(this.context, this.Params.DestinationCode, this.Params.StartDate, this.Params.EndDate, this.getDepartureCapacity).then(function (departure) {
                    if (_this3.$scope.multiDeparture !== 'true') {
                        // Also select departure in case of multideparture.
                        _this3.addDeparture(departure);
                    }
                    _this3.updateReady();
                });
            }

            // log("winresReservationContextService:", this.winresReservationContextService);
            // log("bookingSessionId:", this.winresReservationContextService.bookingSessionId);

            this.updateReady();
        }

        // Adds a departure to shopping cart. This means that all hidden products
        // for the departure will be reserved. Also fetches the hidden price for the
        // departure.
        // For single-departure reservations (multi-departure of the context is not
        // true), this function is called automatically when a departure is loaded.
        // For single-departure reservations, any previous departures will be removed.

    }, {
        key: 'addDeparture',
        value: function addDeparture(departure) {
            if (this.$scope.multiDeparture !== 'true') {
                this.context.Departures = [];
            }
            this.context.Departures.push(departure);
            this.context.HiddenPrice = null;

            // This calculation is now disabled. The calculation is currently broken.
            // The price should always be 0 anyway, so this isn't needed.
            // this.reservationService.calculateHiddenPrice(this.context,
            //                                              this.localizationService.getLanguage())
            //                        .then(result => this.context.HiddenPrice = result);
        }
    }, {
        key: 'initPassengers',
        value: function initPassengers() {
            var _this4 = this;

            if (!this.Params.NumAdult && !this.Params.NumChildren && !this.Params.NumInfants) {
                return;
            }

            if (this.$scope.initPassengers === 'true') {
                var numPassengers = (this.Params.NumAdult || 0) + (this.Params.NumChildren || 0) + (this.Params.NumInfants || 0);

                if (!this.context.Passengers) {
                    this.context.Passengers = [];
                }

                var reusablePassengers = this.context.Passengers.slice();

                this.context.Passengers.length = numPassengers;

                var passengerIndex = 0;
                for (var i = 0; i < this.Params.NumAdult; ++i) {
                    var pax = reusablePassengers.find(function (x) {
                        return x && x.IsAdult;
                    });
                    if (pax) {
                        reusablePassengers.splice(reusablePassengers.indexOf(pax), 1);
                    } else {
                        pax = { Gender: null, IsAdult: true, IsOpen: true };
                    }
                    this.context.Passengers[passengerIndex] = pax;
                    passengerIndex++;
                }

                var _loop = function _loop() {
                    var age = _this4.context.ChildrenAges && _this4.context.ChildrenAges[i] && _this4.context.ChildrenAges[i].Age;
                    var pax = reusablePassengers.find(function (x) {
                        return x && x.IsChild && x.ArrivalAge == age;
                    });
                    if (pax) {
                        reusablePassengers.splice(reusablePassengers.indexOf(pax), 1);
                    } else {
                        pax = { Gender: 'CH', IsChild: true, IsOpen: true };
                    }
                    _this4.context.Passengers[passengerIndex] = pax;
                    passengerIndex++;
                };

                for (var i = 0; i < this.Params.NumChildren; ++i) {
                    _loop();
                }
                for (var i = 0; i < this.Params.NumInfants; ++i) {
                    var _pax = reusablePassengers.find(function (x) {
                        return x && x.IsChild;
                    });
                    if (_pax) {
                        reusablePassengers.splice(reusablePassengers.indexOf(_pax), 1);
                    } else {
                        _pax = { Gender: 'IN', IsInfant: true, IsOpen: true };
                    }
                    this.context.Passengers[passengerIndex] = _pax;
                    passengerIndex++;
                }
            }

            if (this.$scope.initPassengerCounts === 'true' || this.$scope.initPassengers === 'true') {
                this.context.NumAdults = this.Params.NumAdult;
                this.context.NumChildren = this.Params.NumChildren;
                this.context.NumInfants = this.Params.NumInfants;
            }
        }
    }, {
        key: 'initWatches',
        value: function initWatches() {
            var _this5 = this;

            this.$scope.$watchCollection(function () {
                return _this5.customFieldsAppend;
            }, function () {
                return _this5.rebuildPassengerFields();
            });

            this.$scope.$watchCollection(function () {
                return _this5.customFieldsPrepend;
            }, function () {
                return _this5.rebuildPassengerFields();
            });
            this.watchPaymentMethods();

            this.analyticsInitWatches();

            // Watch for any stale linked products whose main product has been removed,
            // and remove the linked products as well.
            this.$scope.$watchCollection(function () {
                return _this5.context && _this5.context.Products;
            }, function () {
                return _this5.removeStaleLinkedProducts();
            });

            // Watch for any passenger assignments in linked products where the passenger
            // is no longer assigned to the main product, and remove the assignments.
            this.$scope.$watch(function () {
                return _this5.getMainProductPassengerAssignments();
            }, function () {
                return _this5.removeStaleLinkedProductPassengerAssignments();
            }, true);
        }

        // Get all passenger assignments for all non-linked products.
        // This is so we can deep-watch this list and notice if it changes.

    }, {
        key: 'getMainProductPassengerAssignments',
        value: function getMainProductPassengerAssignments() {
            return this.context && this.context.Products && _.map(_.filter(this.context.Products, function (line) {
                return !line.Main && line.PassengerAssignments;
            }), function (line) {
                return [lineDestCode(line), lineProdCode(line), lineBeginDate(line), lineEndDate(line), _.map(line.PassengerAssignments, function (pa) {
                    return pa.PassengerNumber;
                })];
            });
        }
    }, {
        key: 'removeStaleLinkedProducts',
        value: function removeStaleLinkedProducts() {
            var _this6 = this;

            if (!this.context || !_.isArrayLike(this.context.Products)) {
                // Nothing to do
                return;
            }

            var lines = this.context.Products;

            var fresh = _.filter(lines, function (line) {
                if (!line.Main) {
                    // Not a linked product whose main is known. Keep it.
                    return true;
                }

                // If this is a destination-linked product, make sure it is either
                // the current selected departure's destination or there is at least
                // one non-linked product with the same destination.
                // Should we also check dates? Is the non-linked product guaranteed
                // to have the same dates as the departure?
                if (!line.Main.prodCode) {
                    var dep = _this6.context.SelectedDeparture;
                    if (dep && dep.DestinationCode == line.Main.destCode) {
                        // Keep it
                        return true;
                    }

                    var found = _.some(lines, function (other) {
                        return !other.Main && lineDestCode(other) == line.Main.destCode;
                    });
                    if (!found) {
                        // log('Linked product line has no matching destination:', line);
                    }
                    return found;
                }

                // This is a product-linked product.

                // Try to find the main product.
                var main = findMainLine(lines, line.Main);

                if (!main) {}
                // log('Linked product line has no matching main product:', line);


                // If we found the main product, keep the line. Otherwise, remove it.
                return main;
            });

            // If some product lines were removed, update the list.
            // Otherwise, avoid triggering any watches.
            var diff = lines.length - fresh.length;
            if (diff > 0) {
                log('Removed', diff, 'stale linked product lines.');
                this.context.Products = fresh;
            }
        }
    }, {
        key: 'removeStaleLinkedProductPassengerAssignments',
        value: function removeStaleLinkedProductPassengerAssignments() {
            var _this7 = this;

            // log('Main product passenger assignments changed.');

            // Find any linked products that are assigned to passengers who are
            // not assigned to the main product. Remove the stale assignments.
            _.forEach(this.context.Products, function (line) {
                if (!line.Main || !line.Main.prodCode || !_.isArrayLike(line.PassengerAssignments)) {
                    // Not a product-linked line or not a passenger-based product.
                    // Do nothing.
                    return;
                }

                var mainLine = findMainLine(_this7.context.Products, line.Main);

                // log('Found main line:', mainLine, line);

                // Remove any passenger assignments that don't have a match in the main.
                var removed = _.remove(line.PassengerAssignments, function (pa) {
                    return !_.some(mainLine.PassengerAssignments, function (mpa) {
                        return pa.PassengerNumber == mpa.PassengerNumber;
                    });
                });

                if (removed.length > 0) {
                    log('Removed', removed.length, 'stale passenger assignments from linked product lines.');
                    // Update changed fields.
                    // NOTE: These assume that multiple passengers are never assigned
                    // to the same service.
                    line.Amount = line.PassengerAssignments.length;
                    line.TotalPrice = _.sumBy(line.PassengerAssignments, function (pa) {
                        return pa.WS_Price;
                    });
                }
            });
        }
    }, {
        key: 'initPassengerFieldsBase',
        value: function initPassengerFieldsBase() {
            // Maxlengths are based on field widths in WINRES databases.
            this.passengerFieldsBase = [{ Name: 'Title', Maxlength: 20 }, { Name: 'Gender' }, { Name: 'FirstName', Maxlength: 30 }, { Name: 'LastName', Maxlength: 25 }, { Name: 'Email', Maxlength: 60 }, { Name: 'MobileNo', Maxlength: 20 }, { Name: 'TelephoneNo', Maxlength: 20 }, { Name: 'StreetAddress', Maxlength: 25 }, { Name: 'PostAddress', Maxlength: 25 }, { Name: 'PostalNumber', Maxlength: 25 }, { Name: 'HomeLocation', Maxlength: 25 }, { Name: 'Group', Maxlength: 30 }, { Name: 'Company', Maxlength: 60 }, { Name: 'BirthDate', Maxlength: 10 }, { Name: 'BirthLocation', Maxlength: 25 }, { Name: 'BirthYear', Maxlength: 4 }, { Name: 'CardNo', Maxlength: 30 }, { Name: 'PassportNo', Maxlength: 13 }, { Name: 'SecurityNo', Maxlength: 5 }, { Name: 'Document', Maxlength: 15 }, { Name: 'Insurance', Maxlength: 30 }, { Name: 'MealPreference', Maxlength: 60 }, { Name: 'AgeCategory', Maxlength: 2 }, { Name: 'FreeField1', Maxlength: 50 }, { Name: 'FreeField2', Maxlength: 50 }, { Name: 'FreeField3', Maxlength: 50 }, { Name: 'FreeField4', Maxlength: 50 }, { Name: 'FreeField5', Maxlength: 50 }, { Name: 'FreeField6', Maxlength: 50 }, { Name: 'FreeField7', Maxlength: 50 }, { Name: 'FreeField8', Maxlength: 50 }];
        }

        // 'visible', 'required', or 'hidden'

    }, {
        key: 'getFieldVisibility',
        value: function getFieldVisibility(fieldName) {
            var settings = this.getPassengerFieldSettings();
            if (!settings) {
                return 'hidden';
            }

            if (!settings[fieldName]) {
                return 'visible';
            }

            if (settings[fieldName].Required) {
                return 'required';
            }

            if (settings[fieldName].Ask) {
                return 'visible';
            } else {
                return 'hidden';
            }
        }
    }, {
        key: 'goToDefaultPhase',
        value: function goToDefaultPhase() {
            this.setCurrentPhase(this.$scope.startphase);
        }

        // Get phase order from shopping tabs then go to next phase.

    }, {
        key: 'goToNextPhase',
        value: function goToNextPhase() {
            if (!this.phaseList) this.setupPhaseList();
            var phaseIdx = this.getPhaseIdx();
            if (phaseIdx == -1) {
                this.showBasketPopup = 'visible';
                var elem = angular.element('#shopping-tabs-anchor');
                if (elem.length) {
                    this.$document.scrollToElement(elem, 200, 100);
                }
                //var payButton = document.querySelector('pay-button');
                //angular.element(payButton).controller('payButton').click();
            } else {
                this.setCurrentPhase(this.phaseList[phaseIdx + 1], true);
            }
        }
    }, {
        key: 'getPhaseIdx',
        value: function getPhaseIdx() {
            var currentPhase = this.winresReservationContextService.getCurrentPhase();
            var selected = -1;
            for (var i = 0; i < this.phaseList.length; i++) {
                var phase = this.phaseList[i];
                if (phase == currentPhase) {
                    selected = i;
                }
            }
            if (!this.phaseList[selected + 1]) return -1;
            return selected;
        }
    }, {
        key: 'addPhase',
        value: function addPhase(phase) {
            if (_.some(this.phaseList, function (p) {
                return p == phase;
            })) return;
            this.phaseList.push(phase);
        }
    }, {
        key: 'addPhaseFromTab',
        value: function addPhaseFromTab(tab) {
            if (tab.localName == 'winres-reservation-shopping-tabs-accommodation') this.addPhase('accommodation');
            //else if(tab.localName=='winres-reservation-shopping-tabs-departure')
            //    this.addPhase('departure');
            else if (tab.localName == 'winres-reservation-shopping-tabs-passenger') this.addPhase('passenger');else if (tab.localName == 'winres-reservation-shopping-tabs-item') this.addPhase(angular.element(tab).controller('winresReservationShoppingTabsItem').phase); // Get phase from component controller.
        }
    }, {
        key: 'setupPhaseList',
        value: function setupPhaseList() {
            var _this8 = this;

            this.phaseList = [];
            if (this.$scope.startphase) this.phaseList.push(this.$scope.startphase);
            var tabsParent = document.querySelector('winres-reservation-shopping-tabs-items');
            var tabs = Array.from(tabsParent.childNodes);
            _.each(tabs, function (tab) {
                if (tab instanceof HTMLElement) {
                    _this8.addPhaseFromTab(tab);
                }
            });
        }
    }, {
        key: 'getDestinationCode',
        value: function getDestinationCode() {
            return this.Params.DestinationCode;
        }
    }, {
        key: 'getStartDate',
        value: function getStartDate() {
            //ISO format
            return this.Params.StartDate;
        }
    }, {
        key: 'getEndDate',
        value: function getEndDate() {
            //ISO format
            return this.Params.EndDate;
        }
    }, {
        key: 'getFieldTitleOverride',
        value: function getFieldTitleOverride(fieldName) {
            return this.winresReservationContextService.getFieldTitleOverride(this.$scope, fieldName);
        }
    }, {
        key: 'rebuildPassengerFields',
        value: function rebuildPassengerFields() {
            if (!this.context) return;
            this.winresReservationContextService.rebuildPassengerFields(this.context, this.passengerFieldsBase, this.customFieldsPrepend, this.customFieldsAppend);
        }

        // Gets the reservation result if the booking was made in this request.
        // It is possible that the reservation data is not initially available
        // because a request is still being made.

    }, {
        key: 'getConfirmBookingResult',
        value: function getConfirmBookingResult() {
            return this.winresReservationContextService.getConfirmBookingResult();
        }
    }, {
        key: 'confirmBookingByInvoice',
        value: function confirmBookingByInvoice() {
            return this.winresReservationContextService.confirmBookingByInvoice(this.contextId);
        }
    }, {
        key: 'getForceGender',
        value: function getForceGender() {
            var result = this.$scope.forceGender;
            if (result == '' || !result) {
                return null;
            }
            return result;
        }
    }, {
        key: 'getContextId',
        value: function getContextId() {
            return this.contextId;
        }

        // Gets reservatio context. If the context is modified, the changes are
        // automatically stored in a local session.

    }, {
        key: 'getContext',
        value: function getContext() {
            return this.context;
        }

        // Gets non-persistent context (one that is not stored in the session).
        // The non-persistent context is used by the reservationContextService to
        // store errors.

    }, {
        key: 'getContextNonPersistent',
        value: function getContextNonPersistent() {
            return this.contextNonPersistent;
        }
    }, {
        key: 'getOwnerData',
        value: function getOwnerData() {
            if (this.ownerDataPromise != null) {
                return this.ownerDataPromise.then(function (data) {
                    return data;
                });
            } else if (this.$scope.ownerNumber != null && this.$scope.ownerName != null) {
                log.error("No ownerNumber or ownerName specified!");
            }
            this.ownerDataPromise = this.ownerService.GetOwnerData(this.$scope.ownerNumber, this.$scope.ownerName, this.localizationService.getLanguage());
            return this.ownerDataPromise.then(function (data) {
                if (data.Status !== 'OK' || data.Minisite === false) {
                    log.error("NO MINISITE!");
                } else if (data.Status === 'OK' && data.Minisite === true) {
                    log("Minisite found");
                } else {
                    log.error("Error in finding minisite.");
                    log("Minisite:", data.Status, data.Minisite);
                }
                return data;
            });
        }
    }, {
        key: 'setCurrentPhase',
        value: function setCurrentPhase(phase, scroll) {
            var _this9 = this;

            this.winresReservationContextService.setCurrentPhase(phase);
            if (scroll) {
                this.$timeout(function () {
                    var elem = angular.element('#reservation-part-' + phase);
                    if (elem.length) {
                        _this9.$document.scrollToElement(elem, 200, 200);
                    }
                });
            }
        }
    }, {
        key: 'getCurrentPhase',
        value: function getCurrentPhase() {
            return this.winresReservationContextService.getCurrentPhase();
        }
    }, {
        key: 'getMode',
        value: function getMode() {
            return this.$scope.mode;
        }
    }, {
        key: 'getErrors',
        value: function getErrors(componentName) {
            return this.winresReservationContextService.getErrors(this.contextId, componentName);
        }
    }, {
        key: 'hasErrors',
        value: function hasErrors() {
            return this.winresReservationContextService.hasErrors(this.contextId);
        }
    }, {
        key: 'getPhaseErrors',
        value: function getPhaseErrors(phase) {
            return this.winresReservationContextService.getPhaseErrors(this.contextId, phase);
        }
    }, {
        key: 'getPassengerFields',
        value: function getPassengerFields() {
            return this.context.passengerFields;
        }
    }, {
        key: 'getPassengerFieldSettings',
        value: function getPassengerFieldSettings() {
            return this.context.passengerFieldSettings;
        }
    }, {
        key: 'setMessageToBooking',
        value: function setMessageToBooking(msg) {
            this.context.MessageToBooking = msg;
        }

        // Adds a custom field to be asked for each passenger. See
        // winresReservationCustomSelect for an example.

    }, {
        key: 'addCustomField',
        value: function addCustomField(fieldSettings, prepend) {
            if (prepend) {
                fieldSettings.Name = 'CustomFieldPrepend' + this.customFieldsPrepend.length;
                this.customFieldsPrepend.push(fieldSettings);
            } else {
                fieldSettings.Name = 'CustomFieldAppend' + this.customFieldsAppend.length;
                this.customFieldsAppend.push(fieldSettings);
            }
            return fieldSettings.Name;
        }

        // Returns ['Teppo Testaaja', ... ] or ['Passenger #1', ...] depending on
        // whether passenger names are entered.

    }, {
        key: 'getPassengerDisplayNames',
        value: function getPassengerDisplayNames() {
            return this.winresReservationContextService.getPassengerDisplayNames(this.contextId, this.$scope.adultDisplayName);
        }

        // Indicate whether or not there are errors in a webcomponent.
        //
        // This should be called when error state of a webComponent changes.
        //
        // componentName: Which component displayed the error. Call to this function
        //                resets the previous errors of that component/subcomponent
        //                combo but not those of other components.
        // subName: See previous. E.g. if there are multiple extra services, show
        //          errors for a particular instance of that component.
        //
        // errors: Array of strings or array of { Message: '', Params: {} }.
        //         Errors will be translated when they are displayed. Params are the
        //         parameters passed to i18next, e.g. if you want to display
        //         'Passenger #2', use translation string of form
        //         'Passenger #__number__' and params of form { number: 2 }

    }, {
        key: 'setReservationComponentErrors',
        value: function setReservationComponentErrors(componentName, subName, errors) {
            this.winresReservationContextService.setReservationComponentErrors(this.contextId, componentName, subName, errors);
        }

        // Broadcasts a show errors event to all components that might want to show
        // it (payment button may show a popup, shoppingtabs may show a popup).

    }, {
        key: 'showErrors',
        value: function showErrors(componentName) {
            // Cannot broadcast only to own scope, because of transclusion
            // ("child components" are not true children)
            this.$rootScope.$broadcast('winresReservationShowErrors', this.getErrors(componentName));
        }

        // Broadcasts specific set of error, not all of them.

    }, {
        key: 'showSpecificErrors',
        value: function showSpecificErrors(errorArray) {
            // Cannot broadcast only to own scope, because of transclusion
            // ("child components" are not true children)
            // 'bottom' is the location of this element. Can be used to transfer any data but it is here used to display the error on different place
            this.$rootScope.$broadcast('winresReservationShowErrors', errorArray, 'bottom-error');
        }

        //this is used with payment options, ie when customer wants to pay the full sum instead of reservation fee.

    }, {
        key: 'setAmountToPay',
        value: function setAmountToPay(amount) {
            //log('AmountToPay:', amount);
            this.amountToPay = amount;
        }

        // Called from winresReservationPaymentMethod (which are transcluded into
        // this component)

    }, {
        key: 'toPayment',
        value: function toPayment(internalName) {
            var _this10 = this;

            log("Going to payment...");

            this.loadingOverlayService.start();

            // We need to clean the OK Url to prevent the bug that happened when customer returned from cancelled payment
            // The Url contained the previous booking number parameter
            // adding '' to Url is a trick to convert it to string instead of a Location object
            // log("Url before cleaning was: " + window.location );
            var cleanedOkUrl = this.cleanOkUrlParameters(window.location + '');
            // log("Cleaned OkUrl is: " + cleanedOkUrl);
            // adding '' to Url is a trick to convert it to string instead of a Location object
            var okUrl = this.$scope.okUrl ? this.$scope.okUrl : cleanedOkUrl;
            // log("okUrl is: " + okUrl);
            var cancelUrl = this.$scope.cancelUrl ? this.$scope.cancelUrl : this.$scope.rejectUrl;
            var rejectUrl = this.$scope.rejectUrl ? this.$scope.rejectUrl : this.$scope.cancelUrl;
            var amountToPay = this.amountToPay;
            if (!cancelUrl) {
                // Temporarily add 'cancel' to url to get correct cancelUrl.
                cancelUrl = this.$location.search('cancel', true).absUrl();

                // Remove 'cancel' from url.
                this.$location.search('cancel', null);

                // Temporarily add 'reject' to url to get correct rejectUrl.
                rejectUrl = this.$location.search('reject', true).absUrl();

                // Remove 'reject' from url.
                this.$location.search('reject', null);

                //cancelUrl = this.$scope.okUrl;
                //rejectUrl = this.$scope.okUrl;
            }

            window.sessionStorage.setItem('originalUrl', window.location.href);

            var request = this.reservationService.prebookAndGetPaymentMethod(this.context, internalName, // e.g. NTS or IN or whatever
            okUrl, cancelUrl, rejectUrl, amountToPay, this.localizationService.getLanguage(),

            // Error handling.
            function (error) {
                _this10.$rootScope.$broadcast('winresPrebookError', error.data);
            }).then(function (result) {
                _this10.loadingOverlayService.stop();
                if (result && result.RedirectData) {
                    if (result.HtmlForm) {
                        try {
                            var form = $(result.RedirectData);
                            $('body').append(form);
                            form.submit();
                            return true;
                        } catch (error) {
                            log.error("Failed to redirect to bank:", error);
                        }
                    } else {
                        window.location = result.RedirectData;
                        return true;
                    }
                }

                // Something failed.
                return false;
            });

            // Google analytics.
            this.analyticsEvent("trackCheckout", 4);

            return request;
        }
    }, {
        key: 'findProductLineByProduct',
        value: function findProductLineByProduct(product, ignoreDates) {
            return _.find(this.context.Products, function (productLine) {
                if (productLine.Product == null) {
                    return false;
                }
                return (ignoreDates || product.BeginDate == productLine.Product.BeginDate) && (ignoreDates || product.EndDate == productLine.Product.EndDate) && (ignoreDates || product.BeginTime == productLine.Product.BeginTime) && (ignoreDates || product.EndTime == productLine.Product.EndTime) && product.DestinationInfo.ProductCode == productLine.Product.DestinationInfo.ProductCode && product.DestinationInfo.DestinationCode == productLine.Product.DestinationInfo.DestinationCode;
            });
        }
    }, {
        key: 'findProductLinesByProduct',
        value: function findProductLinesByProduct(product, ignoreDates) {
            return _.filter(this.context.Products, function (productLine) {
                if (productLine.Product == null) {
                    return false;
                }
                return (ignoreDates || product.BeginDate == productLine.Product.BeginDate) && (ignoreDates || product.EndDate == productLine.Product.EndDate) && product.DestinationInfo.ProductCode == productLine.Product.DestinationInfo.ProductCode && product.DestinationInfo.DestinationCode == productLine.Product.DestinationInfo.DestinationCode;
            });
        }
    }, {
        key: 'findOrCreateProductLineByProduct',
        value: function findOrCreateProductLineByProduct(product) {
            var productLine = this.findProductLineByProduct(product);
            if (!productLine) {
                // Create product line
                productLine = {
                    Product: product,
                    Amount: 0, // Will be set later
                    PassengerAssignments: [],
                    PriceSelections: [],
                    UnitPrice: null,
                    TotalPrice: null
                };
                this.context.Products.push(productLine);

                // this.analyticsInitProduct(this.context.Products[0]);

                // The snippet below can be used to figure out where
                // PassengerAssignments is being replaced.
                // A handler for get could be added to figure out where
                // it's being accessed at all (for example, to add or remove elements).
                // var proxyForProductLine = new Proxy(productLine, {
                //   set (obj, prop, value) {
                //     if (prop == 'PassengerAssignments') {
                //       console.trace();
                //     }
                //     obj[prop] = value;
                //     return true;
                //   }
                // });
                // this.context.Products.push(proxyForProductLine);
            }
            return productLine;
        }
    }, {
        key: 'clearPriceSelections',
        value: function clearPriceSelections(productLine) {
            productLine.PriceSelections = [];
        }
    }, {
        key: 'clearPassengerAssignments',
        value: function clearPassengerAssignments(productLine) {
            productLine.Amount = 0;
            productLine.PassengerAssignments = [];
        }
    }, {
        key: 'findOrCreatePriceSelection',
        value: function findOrCreatePriceSelection(priceIndex, productLine) {
            var priceSelection = _.find(productLine.PriceSelections, function (sel) {
                return sel.PriceIndex == priceIndex;
            });
            if (priceSelection === undefined) {
                priceSelection = {
                    PriceIndex: priceIndex,
                    Amount: 0
                };
                productLine.PriceSelections.push(priceSelection);
            }
            return priceSelection;
        }
    }, {
        key: 'setPriceAmount',
        value: function setPriceAmount(productLine, index, amount) {
            if (!amount && amount !== 0) {
                throw 'Invalid amount.';
            }

            var price = _.find(productLine.Product.ReservablePrices, function (p) {
                return p.Index == index;
            });
            if (!price) {
                log.error('Product has no such price:', index, productLine);
                throw 'No such price.';
            }

            var info = productLine.Product.DestinationInfo;
            log('Set price amount:', info.DestinationCode, info.ProductCode, '-', amount, 'x', '#' + index + ' (' + (price ? price.Label : '???') + ').');

            var selection = this.findOrCreatePriceSelection(index, productLine);
            selection.Amount = amount;

            if (selection.Amount === 0) {
                log('Price selection amount for price index', index, 'is now 0. Removing selection row.');
                _.pull(productLine.PriceSelections, selection);
            }

            productLine.Amount = _.sumBy(productLine.PriceSelections, function (sel) {
                return sel.Amount;
            });

            if (productLine.Amount === 0) {
                log('Product line amount is now 0. Removing product line.');
                _.pull(this.data.Products, productLine);
            }
        }
    }, {
        key: 'addExtraServiceToPassenger',
        value: function addExtraServiceToPassenger(product, passengerIndex, num, comment1, comment2) {
            if (num === undefined) {
                num = 1;
            }
            var productLine = this.findOrCreateProductLineByProduct(product);
            for (var i = 0; i < num; ++i) {
                productLine.PassengerAssignments.push({
                    PassengerNumber: passengerIndex,
                    Comment: comment1,
                    Comment2: comment2
                    //Product index will be added below
                });
            }

            this.renumberExtraServiceAssignments(productLine, passengerIndex);
            productLine.Amount = productLine.PassengerAssignments.length;

            log("addExtraServiceToPassenger", this.context);
        }
    }, {
        key: 'calculateTotalPrice',
        value: function calculateTotalPrice(productLine) {
            var totalPrice = 0;
            _.each(productLine.PriceSelections, function (price) {
                var productPrice = _.find(productLine.Product.ReservablePrices, function (prod) {
                    return prod.Index == price.PriceIndex;
                });
                totalPrice += price.Amount * productPrice.Price;
            });
            productLine.TotalPrice = totalPrice;
        }
    }, {
        key: 'renumberExtraServiceAssignments',
        value: function renumberExtraServiceAssignments(productLine, passengerIndex) {
            // Renumber product indices
            var index = 1;
            _.each(productLine.PassengerAssignments, function (assignment) {
                if (assignment.PassengerNumber == passengerIndex) {
                    assignment.ProductNumber = index++;
                }
            });
        }
    }, {
        key: 'getPassengerAssignments',
        value: function getPassengerAssignments(product, passengerIndex) {
            var productLine = this.findProductLineByProduct(product);
            if (!productLine) {
                return [];
            }
            return _.filter(productLine.PassengerAssignments, function (assignment) {
                return assignment.PassengerNumber == passengerIndex;
            });
        }
    }, {
        key: 'getReservationTermsOpener',
        value: function getReservationTermsOpener() {
            return this.winresReservationContextService.getReservationTermsOpener();
        }
    }, {
        key: 'getNumberSelectedForPassenger',
        value: function getNumberSelectedForPassenger(product, passengerIndex) {
            return this.getPassengerAssignments(product, passengerIndex).length;
        }

        // num = undefined/0 -> remove all

    }, {
        key: 'removeExtraServiceFromPassenger',
        value: function removeExtraServiceFromPassenger(product, passengerIndex, num) {
            var productLine = this.findProductLineByProduct(product);
            if (!productLine) {
                return;
            }
            var passengerAssignments = this.getPassengerAssignments(product, passengerIndex);
            if (num && passengerAssignments.length > num) {
                passengerAssignments.length = num;
            }
            _.pullAll(productLine.PassengerAssignments, passengerAssignments);
            this.renumberExtraServiceAssignments(productLine, passengerIndex);
            productLine.Amount = productLine.PassengerAssignments.length;
            if (productLine.Amount == 0) {
                _.pull(this.context.Products, productLine);
            }
        }
    }, {
        key: 'setMaxPassengers',
        value: function setMaxPassengers(val) {
            this.maxPassengers = val;
            this.sanitizePassengerCount();
        }
    }, {
        key: 'setMinPassengers',
        value: function setMinPassengers(val) {
            this.minPassengers = val;
            this.sanitizePassengerCount();
        }

        // Makes sure there are a correct number of passengers by removing or
        // adding passengers.

    }, {
        key: 'sanitizePassengerCount',
        value: function sanitizePassengerCount() {
            if (!this.context.Passengers) {
                return;
            }
            var max = this.getMaxPassengers(),
                min = this.getMinPassengers();

            if (min > max) {
                return;
            }

            if (this.context.Passengers.length > max) {
                this.context.Passengers.length = max;
            }

            while (this.context.Passengers.length < min) {
                this.context.Passengers.push({ IsOpen: true });
            }
        }
    }, {
        key: 'getMaxPassengers',
        value: function getMaxPassengers() {
            if (this.maxPassengers && this.$scope.maxPassengers) {
                return Math.min(this.maxPassengers, this.$scope.maxPassengers);
            }
            if (this.maxPassengers) {
                return this.maxPassengers;
            }
            return this.$scope.maxPassengers;
        }
    }, {
        key: 'getAllowChildren',
        value: function getAllowChildren() {
            // This was causing a warning for unreachable code.
            // This "return false" has been here since 2017, so it's probably
            // not a big problem.
            // I've commented out the unreachable line below.
            return false;
            // return this.$scope.allowChildren == 'true';
        }
    }, {
        key: 'getMinChildren',
        value: function getMinChildren() {
            return this.minChildren || 0;
        }

        // Other components may set minChildren - e.g. customselects may set it.
        // This was used in Bottas, so that when the family event was selected,
        // minChildren was set to 1.

    }, {
        key: 'setMinChildren',
        value: function setMinChildren(val) {
            this.minChildren = val;
        }
    }, {
        key: 'getMinPassengers',
        value: function getMinPassengers() {
            if (this.minPassengers && this.$scope.minPassengers) {
                return Math.max(this.minPassengers, this.$scope.minPassengers);
            }
            if (this.minPassengers) {
                return this.minPassengers;
            }
            return this.$scope.minPassengers ? this.$scope.minPassengers : 0;
        }

        // Returns passengers if provided, or prototypical passengers if only have
        // numbers.

    }, {
        key: 'getPassengersForPricing',
        value: function getPassengersForPricing(startDate) {
            return this.winresReservationContextService.getPassengersForPricing(this.contextId, startDate);
        }
    }, {
        key: 'getOrCreateDummyPassengers',
        value: function getOrCreateDummyPassengers(eventDate, passengerCounts, childrenAges) {
            return this.winresReservationContextService.getOrCreateDummyPassengers(this.contextId, eventDate, passengerCounts, childrenAges);
        }
    }, {
        key: 'getPaymentMethods',
        value: function getPaymentMethods() {
            if (this.contextNonPersistent.paymentMethodsRequest === undefined) {
                this.updatePaymentMethods();
            }
            return this.contextNonPersistent.paymentMethodsRequest;
        }
    }, {
        key: 'getWinresReservationPaymentMode',
        value: function getWinresReservationPaymentMode() {
            return this.contextNonPersistent.WinresReservationPaymentMode;
        }
    }, {
        key: 'updatePaymentMethods',
        value: function updatePaymentMethods() {
            var _this11 = this;

            var oldRequest = this.contextNonPersistent.paymentMethodsRequest;
            if (oldRequest) {
                // console.log('[WRC]', 'Canceling old request:', oldRequest);
                this.cancelService.cancel(oldRequest);
            }

            var subRequests = {
                wait: null,
                wrc: null
            };

            var request = this.$q.defer();

            request.promise.cancel = function () {
                request.resolve(undefined); // Nobody _should_ be waiting for this, but let's use undefined like some $http does.
                if (subRequests.wait) _this11.cancelService.cancel(subRequests.wait);
                if (subRequests.wrc) _this11.cancelService.cancel(subRequests.wrc);
            };
            this.cancelService.register(request.promise);

            this.contextNonPersistent.paymentMethodsRequest = request.promise;

            if (!this.context.Products || this.context.Products.length == 0) {
                request.resolve(null);
                this.$timeout(function () {
                    return _this11.$rootScope.$broadcast('paymentNoProducts');
                }); // Why timeout?
                return;
            }

            var update = function update() {
                // console.log('[WRC]', 'Updating payment methods.');
                subRequests.wrc = _this11.reservationService.getPaymentMethodsAndParameters(_this11.context, _this11.amountToPay);
                subRequests.wrc.then(function (response) {
                    // Part below based on old code without refactoring.
                    try {
                        if (response && response.PaymentMethods) {
                            request.resolve(response.PaymentMethods);
                            _this11.contextNonPersistent.WinresReservationPaymentMode = response.WinresReservationPaymentMode;
                            _this11.$rootScope.$broadcast('paymentMethodsUpdated', response.PaymentMethods);
                        } else if (response) {
                            request.resolve(response);
                            _this11.$rootScope.$broadcast('paymentMethodsUpdated', response);
                        } else if (response === undefined) {
                            // log.warn("Payment method update canceled.");
                        } else if (response === null) {
                            log.warn("Received no payment methods. Methods are 'null', context is: ", JSON.parse(JSON.stringify(_this11.context)));
                        } else {
                            // log.warn("Received no payment methods. Methods are:", methods);
                        }
                    } catch (e) {
                        log.error("Error updating payment methods:", e);
                        request.reject('error');
                    }
                });
            };

            var lastAt = this.contextNonPersistent.lastPaymentMethodsRequestAt || new Date(2000, 0, 1);
            var waitUntil = lastAt.getTime() + 5000;
            var waitMs = waitUntil - new Date().getTime();

            this.contextNonPersistent.lastPaymentMethodsRequestAt = new Date();

            if (waitMs > 0) {
                log('Waiting', waitMs, 'ms until next update.');
                subRequests.wait = this.$timeout(update, waitMs);
                subRequests.wait.cancel = function () {
                    return _this11.$timeout.cancel(subRequests.wait);
                };
                this.cancelService.register(subRequests.wait);
            } else {
                // console.log('[WRC]', 'No need to wait, updating directly.');
                update();
            }
        }
    }, {
        key: 'watchPaymentMethods',
        value: function watchPaymentMethods() {
            var _this12 = this;

            this.$scope.$watch(function () {
                return _this12.getProductsToWatch();
            }, // GetPaymentmethods and GetPaymentOptions request called multiple times. Source: winresReservationExtraServices.js product.PassengerPrices = [] at line 1597.
            function () {
                return _this12.updatePaymentMethods();
            }, true);
        }
    }, {
        key: 'getProductsToWatch',
        value: function getProductsToWatch() {
            // Only watch relevant product attributes - price is not one of them,
            // since it changes asynchronously and would cause duplicate requests.
            if (!this.context || !this.context.Products) return null;
            var result = _.cloneDeep(this.context.Products);
            _.each(result, function (p) {
                p.TotalPrice = null;
                p.UnitPrice = null;
            });
            return result;
        }
    }, {
        key: 'getUserReservations',
        value: function getUserReservations() {
            var _this13 = this;

            this.winresCloudService.getUserWhenAvailable().then(function (user) {
                var customerID = user.getCustomerId();
                _this13.getRows(customerID);
            });
        }
    }, {
        key: 'getSelectedReservationData',
        value: function getSelectedReservationData(bookingNumber) {
            var _this14 = this;

            this.context.selectedReservation.BookingNumber = bookingNumber; //store for later
            this.customerService.getCustomerBooking(this.context.customerID, bookingNumber).then(function (result) {
                _this14.context.selectedReservation.data = result;
                log("New selected reservation:", result);
            });
        }
    }, {
        key: 'getSelectedReservationExtraServices',
        value: function getSelectedReservationExtraServices() {
            var _this15 = this;

            //log("ExtraServices parameters", this.context.customerID, this.context.selectedReservation.BookingNumber)
            this.customerService.GetReservableExtraServices(this.context.customerID, this.context.selectedReservation.BookingNumber, this.localizationService.getLanguage()).then(function (result) {
                _this15.context.selectedReservation.ExtraServices = result;
                log("New extra services:", result);
            });
        }
    }, {
        key: 'getRows',
        value: function getRows(customerID) {
            var _this16 = this;

            this.ReserveExtraServicesEnabled = true;
            this.PayEnabled = true;
            this.FutureReservations = this.PastReservations = null;
            this.context.customerID = customerID;
            this.customerService.getCustomerBookingList(customerID).then(function (result) {
                log("RAW DATA", result);
                try {
                    result = _.filter(_.map(result, function (row) {
                        var resultRow = {
                            Products: [],
                            Image: null,
                            BookingNumber: row.BookInfos.BookingNumber,
                            TotalPrice: row.BookInfos.TotalPrice,
                            PayLink: row.PayLink,
                            InfoLink: row.InfoLink,
                            ExtraServicesLink: row.ReserveExtraServicesLink
                        };
                        // log('resultrow', resultRow);

                        var passengerCount = null;
                        var room = null;
                        var cabin = null;
                        var fallback = null;

                        _.each(row.Productlines.products, function (product) {
                            if (product.DestinationInfo.ProductCode[0] == 'X' || product.DestinationInfo.DestinationCode[0] == 'X') {
                                return;
                            }

                            if (product.DestinationInfo.ProductCode == '0MAT' || product.DestinationInfo.ProductCode == '1MAT') {
                                passengerCount = product;
                            }

                            if (product.DestinationInfo.ProductType == 'HU') {
                                room = product;
                            }

                            if (product.DestinationInfo.ProductType == 'HY') {
                                cabin = product;
                            }

                            fallback = product;

                            resultRow.Products.push({
                                Title: product.DestinationInfo.ProductName,
                                Headline: product.DestinationInfo.Headline,
                                BeginDate: new Date(product.BeginDate),
                                BeginTime: product.BeginTime,
                                EndDate: new Date(product.EndDate),
                                EndTime: product.EndTime,
                                Price: product.Price
                            });
                        });

                        var product = passengerCount || room || cabin || fallback;

                        if (!product) {
                            return null;
                        }

                        //  log('THE product is', product);

                        resultRow.Headline = product.DestinationInfo.Headline;
                        resultRow.Subtitle = product.DestinationInfo.DestinationName;
                        resultRow.BeginDate = new Date(product.BeginDate);
                        resultRow.EndDate = new Date(product.EndDate);
                        resultRow.BeginTime = product.BeginTime;
                        resultRow.EndTime = product.EndTime;

                        // Find image
                        _.each([passengerCount, room, cabin, fallback], function (product) {
                            if (!product || !product.DestinationInfo.Images || product.DestinationInfo.Images.length == 0) {
                                return;
                            }
                            resultRow.Image = product.DestinationInfo.Images[0];
                        });

                        return resultRow;
                    }));

                    var now = new Date();
                    _this16.context.pastReservations = _.reverse(_.sortBy(_.filter(result, function (o) {
                        return o.EndDate < now;
                    }), function (o) {
                        return o.BeginDate;
                    }));
                    _this16.context.futureReservations = _.sortBy(_.filter(result, function (o) {
                        return o.EndDate >= now;
                    }), function (o) {
                        return o.BeginDate;
                    });
                    _this16.context.selectedReservation = _this16.context.futureReservations[0];
                    _this16.getSelectedReservationData(_this16.context.selectedReservation.BookingNumber);
                } catch (e) {
                    log.error(e);
                }
            });
        }
    }, {
        key: 'getSeoState',
        value: function getSeoState() {
            return this.$scope.useSeo === "true" ? true : false;
        }

        //function that take 2 parameters: the param you are trying to remove and your source URL

    }, {
        key: 'removeUrlParam',
        value: function removeUrlParam(key, sourceURL) {
            log("removeUrlParam removing parameter:", key, "from source url:", sourceURL);
            var rtn = sourceURL.split("?")[0],
                param,
                params_arr = [],
                queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
            if (queryString !== "") {
                params_arr = queryString.split("&");
                for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                    param = params_arr[i].split("=")[0];
                    if (param === key) {
                        params_arr.splice(i, 1);
                    }
                }
                rtn = rtn + "?" + params_arr.join("&");
            }
            return rtn;
        }
    }, {
        key: 'cleanOkUrlParameters',
        value: function cleanOkUrlParameters(inputUrl) {
            log("Cleaning URL...");

            var urlOrderNumRevomed = this.removeUrlParam("ORDER_NUMBER", inputUrl);
            var urlTimeStampRemoved = this.removeUrlParam("TIMESTAMP", urlOrderNumRevomed);
            var urlReturnAuthCodeRemoved = this.removeUrlParam("RETURN_AUTHCODE", urlTimeStampRemoved);
            var urlbookingSessionRemoved = this.removeUrlParam("bookingSessionId", urlReturnAuthCodeRemoved);
            var finalCleanedUrl = urlbookingSessionRemoved;

            return finalCleanedUrl;
        }
    }, {
        key: 'analyticsInitWatches',
        value: function analyticsInitWatches() {
            this.analyticsService.initWatches(this);
        }
    }, {
        key: 'analyticsEvent',
        value: function analyticsEvent(type, data) {
            this.analyticsService.analyticsEvent(type, data);
        }
    }, {
        key: 'dataLayerEvent',
        value: function dataLayerEvent(type, data) {
            this.analyticsService.dataLayerEvent(type, data);
        }
    }]);

    return WinresReservationContextController;
}();

function lineDestCode(line) {
    try {
        var prod = line.Product;
        var di = prod.DestinationInfo;
        return di.DestinationCode;
    } catch (e) {
        log.warn('Failed to get destination code of product line:', line, e);
        return '';
    }
}

function lineProdCode(line) {
    try {
        var prod = line.Product;
        var di = prod.DestinationInfo;
        return di.ProductCode;
    } catch (e) {
        log.warn('Failed to get product code of product line:', line, e);
        return '';
    }
}

function lineBeginDate(line) {
    try {
        var prod = line.Product;
        return prod.BeginDate.substring(0, 10);
    } catch (e) {
        log.warn('Failed to get begin date of product line:', line, e);
        return '';
    }
}

function lineEndDate(line) {
    try {
        var prod = line.Product;
        return prod.EndDate.substring(0, 10);
    } catch (e) {
        log.warn('Failed to get end date of product line:', line, e);
        return '';
    }
}

function findMainLine(lines, main) {
    return _.find(lines, function (line) {
        return lineDestCode(line) == main.destCode && lineProdCode(line) == main.prodCode && lineBeginDate(line) == main.beginDate && lineEndDate(line) == main.endDate;
    });
}

WinresReservationContextController.$inject = ['$q', '$scope', '$rootScope', '$timeout', '$document', '$location', 'winresReservationContextService', 'destinationService', 'localizationService', 'reservationService', 'departureService', 'loadingOverlayService', 'productService', 'winresCloudService', 'customerService', 'ownerService', 'cancelService', 'analyticsService', 'urlService'];

_module3.default.directive('winresReservationContext', function () {
    return {
        restrict: 'AE',
        controller: WinresReservationContextController,
        transclude: true,
        template: '<ng-transclude></ng-transclude>',
        scope: {
            language: '@',

            // If true, use the language specified in the html tag, e.g. <html lang="en">
            useHtmlLang: '@',

            // Congress or Package. Mostly disregarded - currently this
            // information comes from the WinresCloud users UserType.
            mode: '@',

            // ID of the booking session ("shopping cart") - i.e. multiple
            // sessions are allowed in the same session.
            contextId: '@',

            // These override any URL parameters.
            destinationCode: '@',
            // Departure start date (if forced departure) ISO format.
            // Used in e.g. Bottas when specifying a departure to use.
            startDate: '@',
            // Departure end date (if forced departure) ISO format
            // Used in e.g. Bottas when specifying a departure to use.
            endDate: '@',
            productCode: '@',

            startphase: '@',
            // Passenger-specific settings are here, since they are needed both
            // by passenger input and customer input (when customer is also a
            // passenger)
            forceGender: '@',
            // Override the title/label of the company field
            fieldTitleCompany: '@',
            // Override the title/label of the group field
            fieldTitleGroup: '@',

            //the string that replace 'common.adult'
            adultDisplayName: '@',

            // does this site use SEO or not true (default) / false
            useSeo: '@',

            okUrl: "@",
            cancelUrl: "@",
            rejectUrl: "@",
            // Whether Gender fields have an option for selecting children.
            // This does not affect age validation (at least at the present.)
            allowChildren: "@",
            maxPassengers: "@",
            minPassengers: "@",

            // If true, passenger counts passed from the URL are applied to the
            // passenger array.
            // this is basically required, passengers are mandatory to send confirmation emails ect.
            initPassengers: '@',

            // If true, passenger counts passed from the URL are applied to the
            // passenger counts in the context.
            initPassengerCounts: '@',

            // If true, changing departure removes all products from the
            // shopping cart. Default = false, since this makes sence for K&K,
            // not so much for regular package reservations.
            // If this is true, multiDeparture cannot be true.
            // Default: false
            resetProductsOnDepartureChange: '@',

            //if true (Default: false), and there is no destinationCode in url, the defaultdates are set null
            resetDefaultDatesOnDestinationChange: '@',

            // true / false (default). If true, adds display: none to
            // #white-loading-screen when i18next has loaded
            initialLoadingScreen: '@',

            // If true, allows a single reservation to contain multiple
            // departures. this is used e.g. in Oulu and Kymi Keskusvaraamo.
            // where the shopping cart may contain products from many departures.
            // If this is true, resetProductsOnDepartureChange cannot be true.
            // If this is true, the selected departure (departure being viewed)
            // is the same as the departure being reserved. Otherwise, other
            // components must add the departure being reserved into the session.
            // Default: false
            multiDeparture: '@',

            // Must be specified along with clerkId. Sets the email addr of
            // confirmation and kasitteli/virkailija
            officeId: '@',

            // Must be specified along with officeId. Sets the email addr of
            // confirmation and kasitteli/virkailija
            clerkId: '@',

            // true/false (default) if the system supports buses
            busDeparture: '@',

            // if you want to see capacity of departure on kohdesivu set this true. Default: false.
            getCapacity: '@',

            // required if ownerName is not specified when owner is requested.
            ownerNumber: '@',

            // required if ownerNumber is not specified when owner is requested.
            ownerName: '@',

            // Override the code that attempts to detect that we are on a departure page by
            // looking at the URL. This can be used when testing on a page that does not have
            // "departure" or "lahto" in the URL.
            isDeparture: '@',

            // If true, the current page is definitely a destination page, no matter what the URL looks like.
            isDestination: '@',

            // This can't be implemented here since it needs to be available to boot.js.
            // // If true, use the query string (?d1=...) instead of the fragment (#!/...)
            // useQueryString: '@',

            numAdults: '@',
            numChildren: '@',
            numInfants: '@'
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./src/reservation/reservationContextDirective.js
// module id = 551
// module chunks = 2